module.exports = __webpack_public_path__ + "img/ordersManager.53cc6b97.svg";